import {
  AfterContentInit,
  Component,
  forwardRef,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'un-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class SliderComponent
  implements OnInit, ControlValueAccessor, AfterContentInit
{
  @Input() min = 0;
  @Input() max = 100;
  @Input() range?: boolean;
  @Input() showTooltip?: boolean;
  @Input() showInputs?: boolean;
  @Input() disabled?: boolean;
  @Input() formControl?: FormControl;
  @Input() formControlName?: string;

  value: number | number[];
  end?: number;
  start?: number;

  control: FormControl<number | number[] | null>;
  get nzTooltipVisible() {
    return this.showTooltip ? 'default' : 'never';
  }

  constructor(@Optional() private controlContainer?: ControlContainer) {}

  ngOnInit(): void {
    this.end = this.max;
    this.start = this.min;
    this.setControl();
  }

  ngAfterContentInit(): void {
    this.setStartAndEnd();
  }
  setControl() {
    if (this.formControl) this.control = this.formControl;
    else if (this.controlContainer && this.formControlName)
      this.control = this.controlContainer.control?.get(
        this.formControlName
      ) as FormControl;
  }
  setStartAndEnd(value?: number | number[]) {
    const val = value || this.value;
    if (typeof val === 'number') {
      this.start = this.min || 0;
      this.end = val || this.max;
    }
    if (Array.isArray(val) && val.length > 1) {
      this.start = val[0];
      this.end = val[1];
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  propagateChange = (_: number | number[]) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  propagateTouched = () => {};
  writeValue(value: number | number[]): void {
    this.value = value;
    this.setStartAndEnd();
    if (!this.control) this.control = new FormControl(value);
    this.propagateChange(value);
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  updateSlide(value: number | number[] | any) {
    if (this.control || this.formControlName) this.writeValue(value);
    else this.setStartAndEnd(value);
  }
  updateMin($e: Event) {
    let value = +($e.target as HTMLInputElement).value;
    if (!value) return;
    if (value > (this.end || this.max)) {
      this.start = this.end || this.max;
      value = this.start;
    } else if (value < this.min) {
      this.end = this.min;
      value = this.end;
    }
    if (this.range)
      this.control.patchValue([value, (this.value as number[])[1]]);
    else this.control.patchValue(value);
  }
  updateMax($e: Event) {
    let value = +($e.target as HTMLInputElement).value;
    if (!value) return;
    if (value < (this.start || this.min)) {
      this.end = this.start || this.min;
      value = this.end;
    } else if (value > this.max) {
      this.end = this.max;
      value = this.end;
    }
    if (this.range)
      this.control.patchValue([(this.value as number[])[0], value]);
    else this.control.patchValue(value);
  }
}
